import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectLocales } from './brand/ducks/selectors';
import { locale } from '~/store/cookies.js';

const LOCAL = process.env.NODE_ENV === 'development';

const reloadWithDelay = () => {
	// prevent reload loop on local-env
	if (!LOCAL) setTimeout(() => window.location.reload(), 500);
};

const isCurrentLocaleAllowed = allowedLocales => {
	const currentLocale = locale();
	return allowedLocales.some(l => l.locale === currentLocale);
};

const InvalidLocaleReload = () => {
	const allowedLocales = useSelector(selectLocales);
	useEffect(() => {
		if (!isCurrentLocaleAllowed(allowedLocales)) reloadWithDelay();
	}, [allowedLocales]);
	return null;
};

export default InvalidLocaleReload;
